var exports = {
  "kL": "x112a1f60--5a0012--container",
  "Uq": "x112a1f60--5a0012--value",
  "Kk": "x112a1f60--5a0012--icon",
};

module.exports = exports;
